/* FRANTIC STUDIO · Variantenwaechter fuer die Produktseite
   Das Theme holt bei jedem Klick auf eine Option die passende Variante per
   Netzwerk nach. Bei schnellen Klicks kommen Antworten durcheinander an:
   dann zeigt die Seite z. B. Edelstahl 52, im Formular steht aber eine andere
   Variante, oder der Button bleibt grau, obwohl die Groesse lieferbar ist.
   Dieses Skript ist die Sicherung dahinter:
   1. Nach jeder Aenderung wird aus den angeklickten Optionen die echte
      Variante bestimmt (aus /products/handle.js). Formular und Button werden
      darauf gesetzt, egal was das Theme gerade gerendert hat.
   2. Wird ein Material gewaehlt, in dem die bisherige Groesse ausverkauft
      ist, springt die Auswahl auf die naechstliegende lieferbare Groesse.
      Ausnahme: ist fs-variant-autojump.js geladen, macht das der Sprung
      mit Kundenhinweis, und dieser Teil hier pausiert.
   3. Lange Optionswerte bekommen 2 oder 1 Spalte statt 3 (siehe unten).
   4. Sofortanzeige: Preis, ausverkaufte Optionen, Knopf und Bild wechseln
      beim Antippen sofort, nicht erst nach der Serverantwort.
   5. Das Vorladen der naechsten Kombinationen startet schon beim Seitenstart.
   Die Auswahl, die der Kunde sieht (input:checked), ist immer die Wahrheit. */
(function () {
  'use strict';

  function init(pv) {
    if (pv.__fsGuard) return;
    pv.__fsGuard = true;

    var page = pv.closest('[data-js-product-component]') || pv.closest('product-page') || document;
    var url = (pv.dataset.url || '').split('?')[0];
    if (!url) return;

    var product = null;
    var lastRow = -1;
    var autoBusy = false;
    var internal = false;
    var refreshes = 0;
    var timer = null;
    var staleTimer = null;

    function rows() {
      return Array.prototype.slice.call(pv.querySelectorAll('[data-js-product-variant-container]'));
    }
    function inputsOf(row) {
      return Array.prototype.slice.call(row.querySelectorAll('input[type="radio"]'));
    }
    function selection() {
      return rows().map(function (row) {
        var c = row.querySelector('input:checked');
        if (c) return c.value;
        var s = row.querySelector('select');
        return s ? s.value : null;
      });
    }
    function variantFor(vals) {
      if (!product) return null;
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i], ok = true;
        for (var j = 0; j < vals.length; j++) {
          if (v.options[j] !== vals[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    /* 2. Naechstliegende lieferbare Alternative, nur in den Reihen UNTER der
       geaenderten (Material geaendert: Groesse anpassen). Waehlt der Kunde
       eine Groesse, wird nie still das Material gewechselt. */
    function pickAvailable(changedRow) {
      var all = rows();
      var vals = selection();
      for (var r = changedRow + 1; r < all.length; r++) {
        var inputs = inputsOf(all[r]);
        var cur = -1;
        for (var k = 0; k < inputs.length; k++) if (inputs[k].checked) cur = k;
        if (cur < 0) continue;
        var order = [];
        for (var d = 1; d < inputs.length; d++) {
          if (cur + d < inputs.length) order.push(cur + d);
          if (cur - d >= 0) order.push(cur - d);
        }
        for (var o = 0; o < order.length; o++) {
          var test = vals.slice();
          test[r] = inputs[order[o]].value;
          var v = variantFor(test);
          if (v && v.available) {
            var target = inputs[order[o]];
            /* Gesperrt ist sie evtl. nur noch vom vorherigen Material */
            if (target.disabled && !target.hasAttribute('data-disabled')) target.disabled = false;
            autoBusy = true;
            target.click();
            autoBusy = false;
            return true;
          }
        }
      }
      return false;
    }

    /* 1. Formular und Button an die sichtbare Auswahl angleichen */
    function reconcile() {
      timer = null;
      if (!product) return;
      var v = variantFor(selection());
      if (!v) return;
      var id = String(v.id);

      var idInputs = page.querySelectorAll('form input[name="id"]');
      for (var i = 0; i < idInputs.length; i++) {
        if (idInputs[i].value !== id) idInputs[i].value = id;
      }

      var form = page.querySelector('form[action*="/cart/add"]');
      var btn = page.querySelector('[data-js-product-add-to-cart]');
      if (btn) {
        if (v.available) {
          btn.classList.remove('disabled');
          if (form) form.classList.remove('disabled-cart');
        } else {
          btn.classList.add('disabled');
          if (form) form.classList.add('disabled-cart');
        }
      }

      /* Das Theme schreibt beim Klick die Varianten ID des angeklickten
         Knopfes in die Adresse, und die stammt noch von der vorherigen
         Kombination. Hier wird sie auf die echte Variante gesetzt. */
      try {
        var params = new URLSearchParams(location.search);
        if (params.has('variant') && params.get('variant') !== id) {
          params.set('variant', id);
          history.replaceState(history.state, '', location.pathname + '?' + params.toString() + location.hash);
        }
      } catch (e) {}

      /* Preis und Hinweise kommen vom Theme. Zeigt es nach 1,5 Sekunden
         immer noch eine alte Variante, wird es einmal neu angestossen.
         Vorher nicht: kurz nach einem Klick laedt das Theme ja noch, und ein
         zu frueher Anstoss wuerde z. B. den Hinweis des Groessensprungs
         (fs-variant-autojump.js) sofort wieder entfernen. */
      if (shownId() !== id && refreshes < 2 && !staleTimer) {
        staleTimer = setTimeout(refreshIfStale, 1500);
      }
    }

    function shownId() {
      var dataEl = pv.querySelector('[data-js-variant-data]');
      try { var shown = dataEl ? JSON.parse(dataEl.textContent) : null; return shown ? String(shown.id) : null; } catch (e) { return null; }
    }

    function refreshIfStale() {
      staleTimer = null;
      var v = variantFor(selection());
      if (!v) return;
      var shown = shownId();
      if (!shown || shown === String(v.id) || refreshes >= 2) return;
      refreshes++;
      var all = rows();
      var row = all[lastRow >= 0 && lastRow < all.length ? lastRow : 0];
      var checked = row && row.querySelector('input:checked');
      if (checked) {
        /* Zusammenspiel mit fs-variant-autojump.js:
           Steht dessen Hinweis schon da, ist der Sprung erledigt. Dann wird
           die Aenderung als "programmatisch" markiert, damit der Hinweis
           stehen bleibt. Steht er noch nicht da (Theme antwortet langsam),
           bleibt die Markierung weg, sonst wuerde der noch ausstehende
           Sprung vergessen. Ohne das Skript ist beides wirkungslos. */
        if (pv.querySelector('.fs-variant-note')) pv.__fsAutoJump = true;
        internal = true;
        checked.dispatchEvent(new Event('change', { bubbles: true }));
        internal = false;
      }
    }

    function schedule(delay) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(reconcile, delay);
    }

    /* 4. Sofortanzeige beim Antippen
       Das Theme baut nach jedem Wechsel den Produktbereich auf dem Server neu
       (rund 0,5 bis 1 Sekunde, wenn die Kombination noch nicht vorgeladen ist).
       Bis die Antwort da ist, zeigt dieses Skript schon alles Wichtige aus den
       Produktdaten an:
       a) Variantennummer im Formular sowie Preis, Streichpreis und
          Countdown (siehe updatePrice).
       b) Ausverkaufte Optionen werden sofort durchgestrichen bzw. freigegeben,
          nach derselben Regel wie Shopify: erste Reihe lieferbar, wenn es den
          Wert in irgendeiner lieferbaren Variante gibt, jede weitere Reihe
          passend zu den Reihen darueber.
       c) Warenkorb Knopf aktiv oder grau.
       d) Die Galerie springt zum Bild der Variante (nur wo sie als Slider
          laeuft, also auf dem Handy).
       Die Serverantwort ersetzt das danach unbemerkt mit denselben Werten.
       Laeuft in der Capture Phase, also vor allen anderen Reaktionen auf den
       Klick. */
    function markAvailability(vals) {
      var all = rows();
      for (var r = 0; r < all.length; r++) {
        var inputs = inputsOf(all[r]);
        for (var k = 0; k < inputs.length; k++) {
          var inp = inputs[k];
          if (inp.hasAttribute('data-disabled')) continue;
          var ok = false;
          for (var i = 0; i < product.variants.length && !ok; i++) {
            var v = product.variants[i];
            if (!v.available || v.options[r] !== inp.value) continue;
            var match = true;
            for (var j = 0; j < r; j++) if (v.options[j] !== vals[j]) { match = false; break; }
            ok = match;
          }
          var item = inp.closest('.product-variant__item');
          inp.classList.toggle('disabled', !ok);
          if (item) item.classList.toggle('disabled', !ok);
          inp.setAttribute('data-available', ok ? 'true' : 'false');
          /* Die gewaehlte Option nie sperren, sonst kann der Groessensprung
             (fs-variant-autojump.js) nicht mehr sauber weiterschalten. */
          if (!inp.checked) inp.disabled = !ok;
        }
      }
    }

    function showMedia(v) {
      if (!v.featured_media) return;
      var gal = page.querySelector('.product-gallery');
      var sl = gal && gal.querySelector('css-slider');
      if (!sl || !sl.classList.contains('enabled') || typeof sl.changeSlide !== 'function') return;
      var items = gal.querySelectorAll('.product-gallery-item');
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-media-id') === String(v.featured_media.id)) {
          if (sl.index !== i) { try { sl.changeSlide(i); } catch (e) {} }
          return;
        }
      }
    }

    /* Preis sofort setzen, im selben Aufbau wie das Preis Skript des
       Abschnitts (Streichpreis, Sale Preis, Countdown). Das Waehrungsformat
       kommt vom Theme. Zur Sicherheit wird es vorher am gerade angezeigten
       Preis geprueft: weicht es ab (andere Waehrung, anderes Format), wird
       nichts angefasst und der Preis kommt wie bisher vom Server. */
    function money(cents) {
      var ks = (window.KROWN && KROWN.settings) || {};
      var fmt = ks.shop_money_format || ks.money_format || '';
      var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
      if (!m) return null;
      var n = (cents / 100).toFixed(2).split('.');
      var group = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
      var out;
      switch (m[1]) {
        case 'amount': out = group(n[0], ',') + '.' + n[1]; break;
        case 'amount_no_decimals': out = group(String(Math.round(cents / 100)), ','); break;
        case 'amount_with_comma_separator': out = group(n[0], '.') + ',' + n[1]; break;
        case 'amount_no_decimals_with_comma_separator': out = group(String(Math.round(cents / 100)), '.'); break;
        case 'amount_with_apostrophe_separator': out = group(n[0], "'") + '.' + n[1]; break;
        default: return null;
      }
      return fmt.replace(m[0], out);
    }
    function labelsFromScript() {
      var reg = 'Regular price', sale = 'Sale price';
      var s = document.querySelectorAll('script:not([src])');
      for (var i = 0; i < s.length; i++) {
        var t = s[i].textContent;
        if (t.indexOf('CustomPriceWrapper') < 0) continue;
        var a = t.match(/LBL_REGULAR\s*=\s*"([^"]*)"/), b = t.match(/LBL_SALE\s*=\s*"([^"]*)"/);
        if (a) reg = a[1];
        if (b) sale = b[1];
        break;
      }
      return { reg: reg, sale: sale };
    }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function priceFormatTrusted() {
      var wrap = page.querySelector('.custom-price-wrapper');
      var amountEl = wrap && wrap.querySelector('.custom-price-amount');
      var cur = variantFor(selection());
      if (!amountEl || !cur) return false;
      var f = money(cur.price);
      return !!f && amountEl.textContent.indexOf(f) > -1;
    }
    var priceTrusted = null;
    function updatePrice(v) {
      var wrap = page.querySelector('.custom-price-wrapper');
      if (!wrap || priceTrusted !== true) return;
      var p = money(v.price);
      if (!p) return;
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      var L = labelsFromScript();
      wrap.innerHTML = sale
        ? '<del class="custom-compare-price"><span class="visually-hidden">' + esc(L.reg) + ': </span>' + esc(money(v.compare_at_price)) + '</del>' +
          '<span class="custom-price-amount on-sale"><span class="visually-hidden">' + esc(L.sale) + ': </span>' + esc(p) + '</span>'
        : '<span class="custom-price-amount">' + esc(p) + '</span>';
      var timerEl = page.querySelector('.custom-sales-timer');
      if (timerEl) timerEl.style.display = sale ? 'flex' : 'none';
    }

    function instant(e) {
      var t = e.target;
      if (!t || t.type !== 'radio' || !product) return;
      var vals = selection();
      try { markAvailability(vals); } catch (err) {}
      var v = variantFor(vals);
      if (!v) return;
      var id = String(v.id);
      var idInputs = page.querySelectorAll('form input[name="id"]');
      for (var i = 0; i < idInputs.length; i++) idInputs[i].value = id;
      var form = page.querySelector('form[action*="/cart/add"]');
      var btn = page.querySelector('[data-js-product-add-to-cart]');
      if (btn) {
        btn.classList.toggle('disabled', !v.available);
        if (form) form.classList.toggle('disabled-cart', !v.available);
      }
      try { updatePrice(v); } catch (err) {}
      showMedia(v);
    }
    pv.addEventListener('change', instant, true);

    /* 5. Frueher vorladen
       Das Theme laedt alle mit einem Tipp erreichbaren Kombinationen erst,
       wenn die Auswahl ins Bild scrollt. Hier wird dasselbe Vorladen des
       Themes schon angestossen, sobald die Seite fertig geladen ist und der
       Browser Luft hat (Bilder und Erstanzeige haben Vorrang). Es sind
       dieselben Anfragen, die das Theme sowieso stellt, nur ein paar
       Sekunden frueher. Bei Datensparmodus oder 2G Netz wird nichts
       zusaetzlich geladen. */
    function warm() {
      var c = navigator.connection;
      if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
      var inputs = pv.querySelectorAll('input[data-option-value-id]');
      for (var i = 0; i < inputs.length; i++) {
        var inp = inputs[i];
        if (inp.checked || inp.disabled || inp.hasAttribute('data-selected')) continue;
        try { inp.dispatchEvent(new MouseEvent('mouseover', { bubbles: false })); } catch (err) {}
      }
    }
    function warmLater() {
      var go = function () { setTimeout(warm, 300); };
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 2500 });
      else setTimeout(go, 1200);
    }
    if (document.readyState === 'complete') warmLater();
    else window.addEventListener('load', warmLater);

    pv.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'radio') { schedule(150); return; }
      var all = rows();
      for (var r = 0; r < all.length; r++) if (all[r].contains(t)) lastRow = r;
      if (internal) { schedule(150); return; }
      if (staleTimer) { clearTimeout(staleTimer); staleTimer = null; }
      if (!autoBusy) refreshes = 0;
      /* Ist assets/fs-variant-autojump.js aktiv (Groessensprung mit Hinweis
         fuer den Kunden), uebernimmt es den Sprung. Dann springt hier nichts
         doppelt, der Abgleich unten laeuft trotzdem. */
      if (!autoBusy && !window.__fsVariantJump && product && all.length > 1) {
        var v = variantFor(selection());
        if (!v || !v.available) {
          if (pickAvailable(lastRow)) return;
        }
      }
      schedule(150);
    });

    new MutationObserver(function (muts) {
      schedule(120);
      /* Ersetzt das Theme die Variantenwahl nach einem Wechsel, gehen die
         Spaltenklassen verloren: dann neu einpassen. Eigene Klassenwechsel
         an den Reihen loesen das nicht erneut aus. */
      for (var m = 0; m < muts.length; m++) {
        var added = muts[m].addedNodes;
        for (var q = 0; q < added.length; q++) {
          var nd = added[q];
          if (nd.nodeType === 1 && (nd.matches('.product-variant__container--radio, .product-variant, product-variants') || nd.querySelector('.product-variant__container--radio'))) { scheduleFit(); return; }
        }
      }
    }).observe(page, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'value'] });

    fetch(url + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        product = p;
        try { priceTrusted = priceFormatTrusted(); } catch (e) { priceTrusted = false; }
        schedule(0);
      })
      .catch(function () {});
  }

  /* 3. Spalten an lange Werte anpassen. Standard sind 3 Kacheln pro Reihe.
     Passt ein Wort nicht in seine Kachel (z. B. "(CIRCUMFERENCE"), bekommt
     diese Optionsreihe 2 Spalten, notfalls 1. So wird nie mitten im Wort
     umgebrochen. Gilt auch fuer die Schnellansicht. */
  function overflows(container) {
    var labels = container.querySelectorAll('.product-variant__label');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].scrollWidth > labels[i].clientWidth + 1) return true;
    }
    return false;
  }
  /* Bricht ein Wert in seiner Kachel in mehrere Zeilen um? */
  function wraps(label) {
    var r = document.createRange();
    r.selectNodeContents(label);
    var rs = r.getClientRects();
    for (var k = 1; k < rs.length; k++) if (Math.abs(rs[k].top - rs[0].top) > 4) return true;
    return false;
  }
  function wrapShare(container) {
    var labels = container.querySelectorAll('.product-variant__label');
    if (!labels.length) return 0;
    var n = 0;
    for (var i = 0; i < labels.length; i++) if (wraps(labels[i])) n++;
    return n / labels.length;
  }
  /* Lange Reihen (ab 5 Werten, z. B. Groessen auf Deutsch "66 (US GROESSE
     11.5)"): bricht mehr als ein Drittel der Werte zweizeilig um, aber in 2
     Spalten passt jeder Wert in eine Zeile, dann 2 Spalten. Kurze Reihen
     (Material) bleiben bei 3, sonst stuende eine Kachel allein. */
  function fitColumns() {
    var list = document.querySelectorAll('product-page .product-variant__container--radio');
    for (var i = 0; i < list.length; i++) {
      var c = list[i];
      if (!c.offsetWidth) continue;
      var before = c.classList.contains('fs-cols-2') ? 2 : c.classList.contains('fs-cols-1') ? 1 : 3;
      c.classList.remove('fs-cols-2', 'fs-cols-1');
      var cols = 3;
      if (overflows(c)) {
        c.classList.add('fs-cols-2'); cols = 2;
        if (overflows(c)) { c.classList.remove('fs-cols-2'); c.classList.add('fs-cols-1'); cols = 1; }
      } else if (c.querySelectorAll('.product-variant__label').length >= 5 && wrapShare(c) > 0.34) {
        c.classList.add('fs-cols-2'); cols = 2;
        if (overflows(c) || wrapShare(c) > 0) { c.classList.remove('fs-cols-2'); cols = 3; }
      }
      c.__fsCols = cols;
      if (cols !== before) c.__fsColsChanged = Date.now();
    }
  }
  var fitTimer = null;
  function scheduleFit() {
    if (fitTimer) clearTimeout(fitTimer);
    fitTimer = setTimeout(fitColumns, 80);
  }

  function start() {
    var list = document.querySelectorAll('product-variants[data-main-product-page-variants]');
    for (var i = 0; i < list.length; i++) init(list[i]);
    fitColumns();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleFit);
    window.addEventListener('resize', scheduleFit);
    window.addEventListener('load', scheduleFit);
    /* Schnellansicht wird nachgeladen */
    new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var n = muts[m].addedNodes;
        for (var j = 0; j < n.length; j++) {
          if (n[j].nodeType === 1 && (n[j].matches('product-page, product-variants') || n[j].querySelector && n[j].querySelector('product-variants'))) {
            scheduleFit();
            setTimeout(fitColumns, 700); /* nach der Einblend Animation */
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
